import { Plate } from 'grids/plate/plate';

export const PlatesWrapper = (props) => {
  return <Plate {...props} theme="dark" />;
};
